import { render, staticRenderFns } from "./ProductCreation.vue?vue&type=template&id=cb32676e&scoped=true"
import script from "./ProductCreation.vue?vue&type=script&lang=js"
export * from "./ProductCreation.vue?vue&type=script&lang=js"
import style0 from "./ProductCreation.vue?vue&type=style&index=0&id=cb32676e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb32676e",
  null
  
)

export default component.exports